import {
  SET_AGREEMENT_DATA,
  SET_DOCUMENTS_OPTIONS,
  SET_DOCUMENTS_FOR_TABLE,
  SET_LOADER_TRUE,
  SET_LOADER_FALSE,
  CHANGE_AGREEMENT_DATA,
  CHANGE_SELECTED_FIELDS,
  SET_SELECTED_FIELDS,
  SET_MANAGER_EMAIL,
} from './types'

const initialState = {
  isLoader: false,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_AGREEMENT_DATA:
      return {
        ...state,
        agreementData: action.payload,
      }
    case CHANGE_AGREEMENT_DATA:
      return {
        ...state,
        agreementData: {
          ...state.agreementData,
          [action.payload.name]: action.payload.value,
        },
      }
    case SET_DOCUMENTS_OPTIONS:
      return {
        ...state,
        documentOptions: action.payload,
        isLoader: false,
      }
    case SET_LOADER_FALSE:
      return {
        ...state,
        isLoader: false,
      }
    case SET_DOCUMENTS_FOR_TABLE:
      return {
        ...state,
        documentsForTable: action.payload,
      }
    case SET_MANAGER_EMAIL:
      return {
        ...state,
        managerEmail: action.payload.email,
      }
    case SET_LOADER_TRUE:
      return {
        ...state,
        isLoader: true,
      }
    case CHANGE_SELECTED_FIELDS:
      return {
        ...state,
        selectedFields: {
          ...state.selectedFields,
          [action.payload.name]: action.payload.value,
        },
      }
    case SET_SELECTED_FIELDS:
      return {
        ...state,
        selectedFields: action.payload,
      }
    default:
      return state
  }
}
